import { Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ARRIVAL_INSTRUCTIONS_MAX_LENGTH,
  JOB_DESCRIPTION_MAX_LENGTH,
} from "../../../../../app/constants";
import CommonTextField from "../../../../../common/components/functional/commonTextField/CommonTextField";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { FormTitleGrid } from "../../../styles";

export const Description = () => {
  const { t } = useTranslation("order");
  const { control, watch } = useFormContext();
  const { isReadOnly } = watch();

  return (
    <FormSection title={t("common:description")}>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary">{t("workDescriptionFi")}</Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="workDescriptionFi"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              multiline
              rows={7}
              placeholder={t("workDescriptionPlaceholder")}
              inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary" width="100%" textAlign="right">
          {t("arrivalInstructionsFi")}
          <br />
          <span style={{ fontSize: 13 }}>{t("optional")}</span>
        </Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="arrivalInstructionsFi"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              multiline
              minRows={1}
              maxRows={7}
              helperText={t("arrivalInstructionsHelper")}
              inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary" width="100%" textAlign="right">
          {t("workDescriptionEn")}
          <br />
          <span style={{ fontSize: 13 }}>{t("optional")}</span>
        </Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="workDescriptionEn"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              multiline
              rows={7}
              inputProps={{ maxLength: JOB_DESCRIPTION_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary" width="100%" textAlign="right">
          {t("arrivalInstructionsEn")}
          <br />
          <span style={{ fontSize: 13 }}>{t("optional")}</span>
        </Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="arrivalInstructionsEn"
          control={control}
          render={({ field }) => (
            <CommonTextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              multiline
              minRows={1}
              maxRows={7}
              helperText={t("arrivalInstructionsHelper")}
              inputProps={{ maxLength: ARRIVAL_INSTRUCTIONS_MAX_LENGTH }}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};
